import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { SERVER_URL } from "../../constant";
import dp from "../../assets/dp.jpg";
import { PiSuitcaseSimple } from "react-icons/pi";
import { MdAlternateEmail } from "react-icons/md";
import { IoCallOutline } from "react-icons/io5";
import AlertBox from "../../component/AlertBox";
import {
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { CiCalendar } from "react-icons/ci";
import { LuLogIn, LuLogOut } from "react-icons/lu";
import { IoIosTimer } from "react-icons/io";
import { GoPencil } from "react-icons/go";
import { SlOptionsVertical } from "react-icons/sl";
import PaginationBar from "../../component/PaginationBar";
import AccrodianBox from "../../component/AccrodianBox";
import RatingCompo from "../../component/RatingCompo";
import PopOverBox from "../../component/PopOverBox";

function MemberProfile() {
  const { userId } = useParams();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [employeeData, setEmployeeData] = useState([]);
  const [attendanceData, setAttendanceData] = useState([]);
  const [attendancePage, setAttendancePage] = useState(1);
  const [totalAttendancePage, setTotalAttendancePage] = useState(0);
  const [leaveData, setLeaveData] = useState([]);
  const [leavePage, setLeavePage] = useState(1);
  const [totalLeavePage, setTotalLeavePage] = useState(0);
  const [rating, setRating] = useState(0);

  // fetch member details
  async function getTeamMembers() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/get/employee/${userId}`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setEmployeeData(res.data?.data);
      setRating(res.data?.data?.rating);
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage("Member fetch failed");
    } finally {
      setLoading(false);
    }
  }

  // fetch member attendance
  async function getAttendance() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/attendance/employee/get/${userId}/${attendancePage}`,
        method: "get",
        withCredentials: true,
      });
      //   console.log(res.data?.data);
      setTotalAttendancePage(res?.data?.data?.totalPages);
      setAttendanceData(res.data?.data?.data);
    } catch (error) {
      //   console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Attendance fetch failed");
    } finally {
      setLoading(false);
    }
  }

  // fetch member leaves
  async function getLeave() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/leave/all/get/employee/${userId}/${leavePage}`,
        method: "get",
        withCredentials: true,
      });
      // console.log(res.data?.data);
      setTotalLeavePage(res?.data?.data?.totalPages);
      setLeaveData(res.data?.data?.data);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Leave fetch failed");
    } finally {
      setLoading(false);
    }
  }

  // rating to employee
  async function ratingEmployee(rate) {
    if (isNaN(rate)) {
      setOpen(true);
      setSuccess(false);
      setMessage("Something went wrong");
      return null;
    }
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/rating/employee/${userId}/${rate}`,
        method: "get",
        withCredentials: true,
      });
      setRating(rate);
      setOpen(true);
      setSuccess(true);
      setMessage("Rating given successfully");
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Leave fetch failed");
    } finally {
      setLoading(false);
    }
  }

  console.log(leaveData);

  useEffect(() => {
    getTeamMembers();
  }, [userId]);

  useEffect(() => {
    getAttendance();
  }, [attendancePage]);

  useEffect(() => {
    getLeave();
  }, [leavePage]);

  // popover options
  const popOverArray = [
    <section className="w-[8rem]">
      <Link className="text-[15px]" to={`/admin/employee/goal/settings/${userId}`}>Goal Settings</Link>
    </section>,
  ];

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <div className="flex w-full justify-end items-end">
            <span className="hover:bg-slate-200/50 rounded-[10px] p-2">
              <PopOverBox
                trigger={
                  <SlOptionsVertical className="text-slate-600" size={"18px"} />
                }
                dataArray={popOverArray}
              />
            </span>
          </div>
          <div className="flex gap-5 justify-center flex-col items-center">
            <section className="w-[7rem] h-[7rem]">
              <img
                src={`${SERVER_URL}/api/v1/file/view/${employeeData?.logo}`}
                className="w-full h-full object-cover rounded-full"
                alt=""
              />
            </section>
            <section>
              <div className="text-center">
                <p className="text-[20px] font-semibold text-center w-full">
                  {employeeData?.fullName}
                </p>
                <p className="text-[15px] text-slate-500 flex gap-2 justify-center items-center mt-1">
                  <PiSuitcaseSimple size={"20px"} />
                  {employeeData?.role}
                </p>
                <RatingCompo
                  value={rating}
                  setValue={(e) => ratingEmployee(e)}
                />
                <p className="text-[15px] text-slate-500 flex gap-3 mt-1">
                  <span className="flex items-center gap-1">
                    <MdAlternateEmail size={"18px"} />
                    {employeeData?.profEmail}
                  </span>{" "}
                  |{" "}
                  <span className="flex items-center gap-1">
                    <IoCallOutline size={"18px"} />
                    {employeeData?.phoneNumber}
                  </span>
                </p>
              </div>
            </section>
          </div>
          <div className="mt-5">
            <AccrodianBox
              title={"Attendance"}
              titleClass={"!bg-blue-500 !text-white"}
              headClass={"!font-medium"}
              iconClass={"!text-white"}
              id={"1"}
              defaultExpanded
            >
              <div className="mt-5 border">
                <Table area-label="simple table">
                  <TableHead>
                    <TableRow className="">
                      <TableCell className="">
                        <p className="flex justify-start items-center w-full font-medium gap-2 text-center">
                          Date <CiCalendar size={"19px"} />
                        </p>
                      </TableCell>
                      <TableCell className="">
                        <p className="flex justify-center items-center w-full font-medium gap-2 text-center">
                          Day <CiCalendar size={"19px"} />
                        </p>
                      </TableCell>
                      <TableCell className=" ">
                        <p className="flex justify-center items-center w-full font-medium gap-2 text-center">
                          Clock In <LuLogIn size={"19px"} />
                        </p>
                      </TableCell>
                      <TableCell className=" ">
                        <p className="flex justify-center items-center w-full font-medium gap-2 text-center">
                          Clock Out <LuLogOut size={"19px"} />
                        </p>
                      </TableCell>
                      <TableCell className="">
                        <p className="flex justify-center items-center w-full font-medium gap-2 text-center">
                          Work Duration <IoIosTimer size={"19px"} />
                        </p>
                      </TableCell>
                      <TableCell className="">
                        <p className="flex justify-end items-center w-full font-medium gap-2 text-center">
                          Status <GoPencil size={"19px"} />
                        </p>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {attendanceData.map((e, i) => (
                      <TableRow className="hover:bg-slate-100/70 cursor-pointer">
                        <TableCell className="!text-left">
                          <span className="text-[13px] font-medium bg-slate-200 px-3 py-1 rounded-full">
                            {`${e?.dayOfMonth}-${Number(e?.month) + 1}-${
                              e?.year
                            }`}
                          </span>
                        </TableCell>
                        <TableCell className="!text-center">
                          {new Date(
                            `${e?.year}-${Number(e?.month) + 1}-${
                              e?.dayOfMonth
                            }`
                          ).toLocaleDateString("en-US", { weekday: "long" })}
                        </TableCell>
                        <TableCell className="!text-center">
                          {e?.actualLoginTimeStamp || "--:--"}
                        </TableCell>
                        <TableCell className="!text-center">
                          {e?.actualLogoutTimeStamp || "--:--"}
                        </TableCell>
                        <TableCell className="!text-center">
                          {e?.totalWorkingHours || "--"}
                        </TableCell>
                        <TableCell className="!text-right">
                          <span
                            className={`${
                              e?.status === "Present"
                                ? "bg-green-300/30 text-green-800"
                                : e?.status === "Weekly Holiday"
                                ? "bg-blue-300/30 text-blue-800"
                                : e?.status === "Absent"
                                ? "bg-red-300/30 text-red-800"
                                : "bg-slate-300/30 text-slate-800"
                            } font-medium px-3 p-1 rounded-full text-center`}
                          >
                            {e?.status}
                          </span>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <PaginationBar
                  attendancePage={attendancePage}
                  setAttendancePage={setAttendancePage}
                  totalAttendancePage={totalAttendancePage}
                />
              </div>
            </AccrodianBox>
            <AccrodianBox
              title={"Leave"}
              titleClass={"!bg-blue-500 !text-white"}
              headClass={"!font-medium"}
              iconClass={"!text-white"}
              id={"2"}
            >
              <div className="mt-5 border">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Date</TableCell>
                      <TableCell className="!text-center">
                        Leave Option
                      </TableCell>
                      <TableCell className="!text-center">Leave Type</TableCell>
                      <TableCell className="!text-center">Total Days</TableCell>
                      <TableCell className="!text-center">
                        Description
                      </TableCell>
                      <TableCell className="!text-right">Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {leaveData?.map((e, i) => (
                      <TableRow>
                        <TableCell>
                          {e?.totalDays > 1 ? (
                            <span className="text-[13px] bg-slate-200 font-medium px-3 py-1 rounded-full">{`${e?.startDom}-${e?.startMonth}-${e?.startYear} to ${e?.endDom}-${e?.endMonth}-${e?.endYear}`}</span>
                          ) : (
                            <span className="text-[13px] bg-slate-200 font-medium px-3 py-1 rounded-full">{`${e?.startDom}-${e?.startMonth}-${e?.startYear}`}</span>
                          )}
                        </TableCell>
                        <TableCell className="!text-center">
                          {e?.leaveOption === "Full"
                            ? "Full Day"
                            : e?.leaveOption === "FH"
                            ? "First Half"
                            : "Second Half"}
                        </TableCell>
                        <TableCell className="!text-center">
                          {e?.leaveType}
                        </TableCell>
                        <TableCell className="!text-center">
                          {e?.totalDays}
                        </TableCell>
                        <TableCell className="!text-center">
                          {e?.description}
                        </TableCell>
                        <TableCell className="!text-right">
                          {e?.isApproved === undefined ? (
                            <span className="text-[13px] bg-yellow-200 text-yellow-700 px-3 py-1 font-medium rounded-full">
                              Pending
                            </span>
                          ) : e?.isApproved === true ? (
                            <span className="text-[13px] bg-green-200 text-green-700 px-3 py-1 font-medium rounded-full">
                              Approved
                            </span>
                          ) : e?.isRevoked === true ? (
                            <span className="text-[13px] bg-red-200 text-red-700 px-3 py-1 font-medium rounded-full">
                              Revoked
                            </span>
                          ) : (
                            <span className="text-[13px] bg-red-200 text-red-700 px-3 py-1 font-medium rounded-full">
                              Rejeced
                            </span>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <PaginationBar
                  attendancePage={leavePage}
                  setAttendancePage={setLeavePage}
                  totalAttendancePage={totalLeavePage}
                />
              </div>
            </AccrodianBox>
          </div>
        </div>
      </div>
    </>
  );
}

export default MemberProfile;
